var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-page"},[_c('RichTextPopup',{attrs:{"isActive":true,"content":_vm.post.content.rendered,"blocks":_vm.post.acf.content_blocks || []},on:{"close-popup":_vm.back}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }